import api from "./index";

export interface EducationProtocolListParams {
  number?: string;
  ownerId?: string;
  companyId?: string;
  courseId?: string;
  categoryId?: string;
  listenersIds?: Array<string>;
  listenerUserIds?: Array<string>;
  protocolCreatedAtMin?: Date;
  protocolCreatedAtMax?: Date;
  signedAt?: boolean;
  signedAtMin?: Date;
  signedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  laborProtectionExportedAtMin?: Date;
  laborProtectionExportedAtMax?: Date;
  isLaborProtectionExported?: boolean;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "updatedAt" | "protocolCreatedAt" | "signedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: EducationProtocolListParams, options?: any) => {
  return api.EducationProtocolApi.listShort(
    params.number,
    params.ownerId,
    params.companyId,
    params.courseId,
    params.categoryId,
    params.listenersIds,
    params.listenerUserIds,
    params.protocolCreatedAtMin,
    params.protocolCreatedAtMax,
    params.signedAt,
    params.signedAtMin,
    params.signedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.laborProtectionExportedAtMin,
    params.laborProtectionExportedAtMax,
    params.isLaborProtectionExported,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
